(() => {
  if (customElements.get('dn-daily-timer')) return;
  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', hourCycle: 'h23',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
  customElements.define('dn-daily-timer', class extends HTMLElement {
    connectedCallback() {
      this.tick = () => {
        const parts = Object.fromEntries(clock.formatToParts(new Date()).map(p => [p.type, p.value]));
        const remaining = 86400 - (+parts.hour * 3600 + +parts.minute * 60 + +parts.second);
        const value = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60]
          .map(n => String(n).padStart(2, '0')).join(':');
        const display = this.querySelector('[data-dn-time]');
        if (display) display.textContent = value;
      };
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
})();
